import { render, staticRenderFns } from "./custom-workflow.vue?vue&type=template&id=548a42d8"
import script from "./custom-workflow.vue?vue&type=script&lang=js"
export * from "./custom-workflow.vue?vue&type=script&lang=js"
import style0 from "./custom-workflow.vue?vue&type=style&index=0&id=548a42d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports